// Third-party

// Hooks
import { useMessageFilter } from '@/utils/hooks/conversations/useMessageFilter';

// Constants/Libs
import { MESSAGE_FILTER_META } from '@/components/pages/conversations/SocialInbox/const';

// Components
import Icon from '@/components/base/Icon';
import { useMessages } from '@/utils/hooks/conversations/useMessages';
import Loader from '@/components/base/Loader';

export function SocialInboxActions() {
    const { messageFilter } = useMessageFilter();
    const { isLoading, isLoadingMore, refreshMessages } = useMessages();

    return (
        <div className="flex space-x-3">
            {messageFilter !== MESSAGE_FILTER_META.dm.key && (
                <>
                    {/* TODO: Group Conversation V2 */}
                    {/* <Icon icon="trash" className="text-12 text-icoBlack dark:text-white" />
                    <Icon icon="mail-open" className="text-12 text-icoBlack dark:text-white" /> */}
                    {!isLoading || isLoadingMore ? (
                        <Icon
                            icon="refresh"
                            className="text-12 cursor-pointer text-icoBlack dark:text-white"
                            onClick={refreshMessages}
                        />
                    ) : (
                        <Loader className="size-4 text-icoBlack dark:text-white" />
                    )}
                    {/* TODO: Group Conversation V2 */}
                    {/* <Icon icon="mail" className="text-12 text-icoBlack dark:text-white" /> */}
                </>
            )}

            {messageFilter == MESSAGE_FILTER_META.dm.key && (
                <>
                    <div className="w-px bg-icoGray-300 dark:bg-icoDarkMode-beton" />

                    <button className="flex items-center space-x-2 text-icoBlack dark:text-white">
                        <div className="flex size-4 items-center justify-center rounded border-2 dark:border-icoDarkMode-wolf">
                            <Icon icon="check" className="text-16" />
                        </div>

                        <span className="hidden text-sm sm:block">Select All</span>
                    </button>
                </>
            )}
        </div>
    );
}
